import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import { Publish } from "@material-ui/icons"
// Data
import { createPageContent } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   Title,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledButton,
   StyledTextArea,
   ButtonContainer,
   ButtonWrapper,
   Message,
   CreateImage,
   UploadIcon,
} from "./NewPageContent.styles"

const NewPageContent = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [contentInputs, setContentInputs] = useState({})

   const handleChange = (e) => {
      setContentInputs((prev) => {
         return { ...prev, [e.target.name]: e.target.value }
      })
   }

   const handleImage = (e, side) => {
      const storage = getStorage(app)
      const fileName =
         contentInputs.page + "_" + contentInputs.section + "_" + side
      const storageRef = ref(storage, `PageContents/${fileName}`)
      const uploadTask = uploadBytesResumable(storageRef, e.target.files[0])

      uploadTask.on(
         "state_changed",
         (snapshot) => {
            const progress =
               (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            console.log("Upload is " + progress + "% done")
            switch (snapshot.state) {
               case "paused":
                  console.log("Upload is paused")
                  break
               case "running":
                  console.log("Upload is running")
                  break
               default:
            }
         },
         (error) => {
            console.log(error)
         },
         () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
               console.log("File available at", downloadURL)
               if (side === "left") {
                  setContentInputs((prev) => {
                     return { ...prev, imageLeft: downloadURL }
                  })
               } else if (side === "right") {
                  setContentInputs((prev) => {
                     return { ...prev, imageRight: downloadURL }
                  })
               } else {
                  setContentInputs((prev) => {
                     return { ...prev, imageCenter: downloadURL }
                  })
               }
            })
         }
      )
      console.log(contentInputs)
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      const res = await createPageContent(contentInputs, dispatch)
      if (res === "success") {
         navigate("/page-contents")
      } else {
         setErrorMessage(JSON.stringify(res))
      }
   }

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <Title>New Page Content</Title>
               <StyledForm>
                  <FormItem>
                     <StyledLabel>Page</StyledLabel>
                     <StyledInput
                        type="text"
                        name="page"
                        placeholder="story"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Section</StyledLabel>
                     <StyledInput
                        type="number"
                        name="section"
                        placeholder={0}
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Title FR</StyledLabel>
                     <StyledTextArea
                        name="titleFr"
                        placeholder="Fabrication française"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Title En</StyledLabel>
                     <StyledTextArea
                        name="titleEn"
                        placeholder="French made"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Text FR</StyledLabel>
                     <StyledTextArea
                        name="textFr"
                        placeholder="bla bla bla français"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Text EN</StyledLabel>
                     <StyledTextArea
                        name="textEn"
                        placeholder="bla bla bla english"
                        onChange={handleChange}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Image Left</StyledLabel>
                     <CreateImage src={contentInputs.imageLeft} />
                     <StyledLabel htmlFor={"left_file"}>
                        <UploadIcon>
                           <Publish />
                        </UploadIcon>
                     </StyledLabel>
                     <StyledInput
                        type="file"
                        id="left_file"
                        name="left_file"
                        style={{ display: "none" }}
                        multiple={false}
                        onChange={(e) => handleImage(e, "left")}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Image Center</StyledLabel>
                     <CreateImage src={contentInputs.imageCenter} />
                     <StyledLabel htmlFor={"center_file"}>
                        <UploadIcon>
                           <Publish />
                        </UploadIcon>
                     </StyledLabel>
                     <StyledInput
                        type="file"
                        id="center_file"
                        name="center_file"
                        style={{ display: "none" }}
                        multiple={false}
                        onChange={(e) => handleImage(e, "center")}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Image Right</StyledLabel>
                     <CreateImage src={contentInputs.imageRight} />
                     <StyledLabel htmlFor={"right_file"}>
                        <UploadIcon>
                           <Publish />
                        </UploadIcon>
                     </StyledLabel>
                     <StyledInput
                        type="file"
                        id="right_file"
                        name="right_file"
                        style={{ display: "none" }}
                        multiple={false}
                        onChange={(e) => handleImage(e, "right")}
                     />
                  </FormItem>
               </StyledForm>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Create</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default NewPageContent
